/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module Inputs
 */

/** Enum for Input status
 * @public
 */
export enum InputStatus {
  Success = "success",
  Warning = "warning",
  Error = "error",
}
